<div>
  <form [formGroup]="form">
    <div class="fields-container">
      <div class="field-control">
        <app-text-field
          [label]="'COO.CONSIGNEE_FORM.NAME' | translate"
          [control]="form.get('name')!"
        ></app-text-field>
      </div>
      <div class="field-control">
          <app-option-field
            [label]="'COO.CONSIGNEE_FORM.COUNTRY' | translate"
            [control]="form.get('country')!"
            [country]="true"
            [lovType]="isGSPCertificate ? LookupKey.COO_GSP_DC_COUNTRY : LookupKey.COUNTRY"
          ></app-option-field>    
      </div>
      <div class="field-control">
        <app-text-field
          [label]="'COO.CONSIGNEE_FORM.CITY' | translate"
          [control]="form.get('city')!"
        />
      </div>
      <div class="field-control">
        <app-mobile-number
          [label]="'COO.CONSIGNEE_FORM.PHONE' | translate"
          [control]="form.get('phone')!"
          [countryCodeControl]="form.get('countryCode')!"
          [validationMessages]="{
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
            uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
          }"
        />
        @if (
          form.get('phone')?.value &&
          !form.get('countryCode')?.value &&
          (form.get('countryCode')?.touched || form.get('phone')?.touched)
        ) {
          <div class="fields-error-container">
            {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
          </div>
        }
      </div>
      <div class="field-control">
        <app-text-field
          [type]="'big-text'"
          [label]="'COO.CONSIGNEE_FORM.ADDRESS' | translate"
          [control]="form.get('address')!"
          [maxlength]="110"   
        ></app-text-field>
      </div>
      <div class="field-control">
        <app-text-field
          [label]="'COO.CONSIGNEE_FORM.POBOX' | translate"
          [control]="form.get('poBox')!"
        ></app-text-field>
      </div>
      <!-- <div class="field-control">
        <app-text-field
          [label]="'COO.CONSIGNEE_FORM.FAX' | translate"
          [control]="form.get('fax')!"
        ></app-text-field>
      </div> -->
      <!-- actions -->
      <div class="buttons-group">
        <app-button
          classesName="btn-edge-cut btn-width-auto"
          [label]="'BUTTONS.ADD' | translate"
          (onBtnClick)="add()"
        ></app-button>

        <app-button
          classesName="card-edge-cut-white btn-width-auto"
          [label]="'BUTTONS.CANCEL' | translate"
          (onBtnClick)="close()"
        ></app-button>
      </div>
    </div>
  </form>
</div>
